import React from 'react';
import { Drawer } from 'vaul';
import { Z_INDEX } from '../../constants/zIndex';

type Props = {
    children: React.ReactNode;
    isOpen: boolean;
    onClose: () => void;
    onOpen: () => void;
    openDrawerHeight?: number | string;
    zIndex?: number;
    showHandle?: boolean;
    snapPoints?: (number | string)[];
    modal?: boolean;
    dismissible?: boolean;
    hideBackdrop?: boolean;
    minDrawerHeight?: number | string;
};

const PredefinedSwipableDrawer = (props: Props) => {
    const {
        children,
        isOpen,
        onClose,
        openDrawerHeight,
        zIndex = Z_INDEX.DRAWER_DEFAULT,
        showHandle = true,
        snapPoints,
        modal = true,
        dismissible = true,
        hideBackdrop = false,
        minDrawerHeight,
    } = props;

    const [snap, setSnap] = React.useState<number | string | null>(
        snapPoints ? snapPoints[0] : null
    );

    const handleOpenChange = (open: boolean) => {
        if (!open) {
            onClose();
        }
    };

    return (
        <Drawer.Root
            repositionInputs={false}
            open={isOpen}
            onOpenChange={handleOpenChange}
            snapPoints={snapPoints}
            activeSnapPoint={snap}
            setActiveSnapPoint={setSnap}
            modal={modal}
            dismissible={dismissible}
            noBodyStyles>
            <Drawer.Portal>
                {!hideBackdrop && (
                    <Drawer.Overlay
                        style={{
                            position: 'fixed',
                            inset: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.4)',
                            zIndex: zIndex,
                            display: isOpen ? 'block' : 'none',
                        }}
                    />
                )}
                <Drawer.Content
                    style={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        height: openDrawerHeight || '100%',
                        backgroundColor: '#fff',
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                        zIndex: zIndex,
                        display: 'flex',
                        flexDirection: 'column',
                        maxHeight: openDrawerHeight || 'calc(100% - 80px)',
                        minHeight: minDrawerHeight || '100%',
                        touchAction: 'none',
                        outline: 'none',
                    }}>
                    {showHandle && (
                        <Drawer.Handle
                            style={{
                                width: 32,
                                height: 2,
                                backgroundColor: '#000000',
                                borderRadius: 5,
                                margin: '10px auto',
                                outline: 'none',
                            }}
                        />
                    )}
                    {children}
                </Drawer.Content>
            </Drawer.Portal>
        </Drawer.Root>
    );
};

export default PredefinedSwipableDrawer;
